// User-facing agent copy, centralised so phrasing (and its curly apostrophes)
// stays consistent across surfaces and is easy to localise later.

/** Approval card — why a human sign-off is always required. */
export const APPROVAL_UNDO_WARNING =
  'This action can’t be quietly undone, so it always needs a human sign-off. Nothing runs until you decide.';

/** Approval card — the decision POST failed. */
export const APPROVAL_RECORD_FAILED =
  'Couldn’t record the decision — try again.';

/** File intake card — document parsing failed (fallback when the server sends no message). */
export const FILE_PARSE_FAILED = 'Couldn’t read this document';

/** Step timeline — the context-load step errored. */
export const STEP_CONTEXT_LOAD_FAILED = 'Couldn’t load context';

/** Thread notice — the streamed turn ended without finishing. */
export const TURN_INCOMPLETE = 'That reply didn’t complete.';

/** Job card — a not-yet-published job has no candidate pipeline to show. */
export const JOB_PIPELINE_UNPUBLISHED =
  'Not published yet — no pipeline to show.';
